// extracted by mini-css-extract-plugin
export default {"page":"styles_page__ziDF9","info":"styles_info__z1Prj","startButton":"styles_startButton__OwqKd","canvas":"styles_canvas__KlU7t"};